import Deferred from './deferred'
/**
 * This module is responsible for providing access to
 * information it receives from from the parent page
 */

const ClientInfoService = (clientLibraryComm) => {
  if (!clientLibraryComm) {
    return {}
  }

  const widgetHelpersDeferred = Deferred()
  const optionsDeferred = Deferred()
  const snowplowContextDeferred = Deferred()

  clientLibraryComm.listenOnce('widgetHelpers', (serializedHelpers) => {
    widgetHelpersDeferred.resolve(JSON.parse(serializedHelpers))
  })
  clientLibraryComm.sendMessage('widgetHelpersRequest')

  clientLibraryComm.listenOnce('options', (serializedOptions) => {
    optionsDeferred.resolve(JSON.parse(serializedOptions))
  })
  clientLibraryComm.sendMessage('optionsRequest')

  clientLibraryComm.listenOnce('spContext', (serializedSpContext) => {
    snowplowContextDeferred.resolve(JSON.parse(serializedSpContext))
  })
  clientLibraryComm.sendMessage('spContextRequest')

  return {
    widgetHelpersDeferred,
    optionsDeferred,
    snowplowContextDeferred,
  }
}

export default ClientInfoService
